import styled from '@emotion/styled';
import { percentageFormatter } from '@dnhb/formatters';
import Percentage from 'shared/components/Percentage';
import useMedia from 'shared/hooks/useMedia';
import Color from 'color';

const monthsInYear = 12;
const backgroundColorTransformer = (color) => Color(color).alpha(0.15).rgb().string()

const columnActiveState = ({ active, isPreferred, theme }) =>
  active && {
    backgroundColor: backgroundColorTransformer(isPreferred ? theme.highlightColor : theme.primaryColor),
    justifyContent: 'center',
    color: theme.primaryColor,
    fontWeight: 800,
  };

const mobileColumnActiveState = ({ active, isPreferred, openOnMobile, theme }) =>
  active && {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    boxSizing: 'border-box',
    padding: 24,
    paddingLeft: 8,
    backgroundColor: (isPreferred && !openOnMobile) ? backgroundColorTransformer(theme.highlightColor) : 'transparent',
  };

const Text = styled.span(props => ({
  display: 'none',
  [`@media ${props.theme.mobile}`]: {
    display: 'block',
    marginTop: '12px',
    textAlign: 'right',
    fontSize: '14px',
    lineHeight: '16px',
    fontWeight: 600,
    letterSpacing: '-0.3px',
  },
}));

export const RateCell = styled.div(props => ({
  flex: '64px 1 0',
  fontWeight: 600,
  fontSize: '14px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  color: props.theme.primaryFontColor,

  ...columnActiveState(props),

  [`@media ${props.theme.mobile}`]: {
    display: 'none',
    ...mobileColumnActiveState(props),
  },
}));

const TableRowRateCells = ({ rates, input, openOnMobile, isPreferred }) => {
  const ratesItems = rates.filter(rate => input.frt.includes(rate.frt));

  const { onMobile } = useMedia();

  return input.frt.map((frt, i) => {
    const frtObject = ratesItems.find(rate => rate.frt === frt);
    const RateFormat = () =>
      onMobile ? (
        <Percentage value={frtObject.interest_rate} fontSize="32" fontWeight="800" showDecimals />
      ) : (
        percentageFormatter(frtObject.interest_rate)
      );

    return (
      <RateCell
        isPreferred={isPreferred}
        active={input.sorted_frt === frtObject.frt}
        openOnMobile={openOnMobile}
        index={i + 4}
        key={frt + i}
      >
        {frtObject.interest_rate ? <RateFormat /> : '-'}
          <Text index={i + 2}>
            {frtObject.frt === 0 ? (
              <strong>Variabel</strong>
            ) : (
              <><strong>{frtObject.frt / monthsInYear} jaar</strong> rentevast</>
            )}
          </Text>
      </RateCell>
    );
  });
};

export default TableRowRateCells;
